import { render, staticRenderFns } from "./FreeShiftBreakDialog.vue?vue&type=template&id=0983c653&scoped=true&lang=pug&"
import script from "./FreeShiftBreakDialog.vue?vue&type=script&lang=ts&"
export * from "./FreeShiftBreakDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983c653",
  null
  
)

export default component.exports